import { message } from "antd";
import axios from "axios";
import { BASE_URL } from "../../constant/api";

export const getAllRsa = () => async dispatch => {

    dispatch({ type: 'RSA_LOADED', payload: false })
    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.get(BASE_URL + '/api/rsa')
        dispatch({ type: 'GET_ALL_RSA', payload: response.data })
        dispatch({ type: 'RSA_LOADED', payload: true })
        dispatch({ type: 'LOADING', payload: false })
    } catch (error) {
        console.log(error)
        dispatch({ type: 'RSA_LOADED', payload: true })
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const postRsa = (values) => async dispatch => {

    values.postedBy = JSON.parse(localStorage.getItem('user'))._id

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + '/api/rsa', values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Refrigeration Sub Assembly posted successfully')

        setTimeout(() => {
            window.location.href = '/rsa'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const editRsa = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/rsa/" + values._id, values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Refrigeration Sub Assembly edited successfully')

        setTimeout(() => {
            window.location.href = '/rsa'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const deleteRsa = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/rsa", values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('Refrigeration Sub Assembly deleted successfully')

        setTimeout(() => {
            window.location.href = '/rsa'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};

export const importExcel = (values) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true })
    try {
        const response = await axios.post(BASE_URL + "/api/import-file", values)
        dispatch({ type: 'LOADING', payload: false })
        message.success('File uploaded successfully')

        setTimeout(() => {
            window.location.href = '/rsa'
        }, 1000);

    } catch (error) {
        console.log(error)
        dispatch({ type: 'LOADING', payload: false })
    }
};